import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NavigationButton = React.forwardRef(({ onClick }, ref) => {

  const { t } = useTranslation();

  return (
    <div ref={ref} className="fixed bottom-6 right-6 z-50">
      <button
        onClick={onClick}
        className="group relative flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white text-sm font-medium rounded-lg
          shadow-md hover:shadow-lg transform hover:-translate-y-0.5 
          transition-all duration-200 ease-in-out
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        <span className="relative z-10">{t("form.button.next")}</span>
        <ArrowRight 
          size={20}
          className="relative z-10 transform group-hover:translate-x-1 transition-transform duration-200"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-400 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
      </button>
    </div>
  );
});

export default NavigationButton;